import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import InteractiveTable from "./InteractiveTable";

import CustomToolbarSelect from "./CustomToolbarSelect";
import { nationalities } from "../Variables/Nationalities";

const styles = theme => ({});

class RunnersTable extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { data } = this.props;
    const columns = [
      { name: "Bib Number", options: { filter: false } },
      { name: "First Name", options: { filter: false } },
      { name: "Last Name", options: { filter: false } },
      { name: "DOB", options: { filter: false } },
      { name: "ID", options: { filter: false, display: true } },
      { name: "Gender", options: { filter: false } },
      { name: "Email", options: { filter: false } },
      { name: "Phone", options: { filter: false } },
      { name: "Nationality", options: { filter: false, display: true } },
      { name: "Volunteer", options: { filter: true } },
      { name: "Time Registered", options: { filter: false, display: true } },
      { name: "Confirmation email", options: { filter: true } },
      { name: "Runs", options: { filter: false } }
    ];

    const interactiveTableKeys = [
      {
        id: "bibNumber",
        label: "Bib Number",
        disabled: true,
        column: { name: "Bib", options: { filter: false } }
      },
      {
        id: "firstName",
        label: "first_name",
        column: { name: "First Name", options: { filter: false } }
      },
      {
        id: "surname",
        lable: "Surname",
        column: { name: "Last Name", options: { filter: false } }
      },
      {
        id: "dob",
        label: "DOB",
        column: { name: "DOB", options: { filter: false, display: false } }
      },
      {
        id: "ecName",
        label: "EC Name",
        column: { name: "EC Name", options: { filter: false } }
      },
      {
        id: "ecPhone",
        label: "EC Phone",
        column: { name: "EC Phone", options: { filter: false } }
      },
      {
        id: "idNumber",
        label: "ID",
        column: { name: "ID", options: { filter: false, display: false } }
      },
      {
        id: "gender",
        label: "Gender",
        type: "select",
        items: [
          { label: "Male", value: "Male" },
          { label: "Female", value: "Female" }
        ],
        column: { name: "Gender", options: { filter: false } }
      },
      {
        id: "email",
        label: "Email",
        column: { name: "Email", options: { filter: true } }
      },
      {
        id: "phone",
        label: "Phone",
        column: { name: "Phone", options: { filter: true } }
      },
      {
        id: "nationality",
        label: "Nationality",
        type: "select",
        items: nationalities,
        column: {
          name: "Nationality",
          options: { filter: true, display: false }
        }
      },
      {
        id: "volunteer",
        label: "Volunteer",
        column: {
          name: "volunteer",
          options: { filter: true, display: false }
        }
      },
      {
        id: "timeRegistered",
        label: "Time Registered",
        column: {
          name: "Registration",
          options: { display: false, filter: false }
        }
      },
      {
        id: "registrationEmail",
        label: "Confirmation Email",
        column: {
          name: "Confirmation Email",
          options: { display: true, filter: true }
        }
      },
      {
        id: "runs",
        disabled: true,
        staticIndex: 0,
        column: { name: "Runs", options: { display: true, filter: true } }
      }
    ];
    const options = {
      responsive: "scroll",
      customToolbarSelect: selectedRows => {
        return <CustomToolbarSelect selectedRows={selectedRows} data={data} />;
      }
    };
    return (
      <React.Fragment>
        <InteractiveTable
          title={"Interactive Table"}
          firebaseRef={"users"}
          dataKeys={interactiveTableKeys}
          columns={columns}
          options={options}
          staticData={[data.map(row => row[12])]}
        />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(RunnersTable);
